import { createContext, useCallback, useContext, useState } from 'react';

import CallDrawer from '../components/crm/voice/crm.call.drawer';

const VoiceCallContext = createContext({ openCallDrawer: () => {} });

export const useVoiceCallDrawer = () => useContext(VoiceCallContext);

export const VoiceCallProvider = ({ children }) => {

    const [callRequest, setCallRequest] = useState(null);

    const openCallDrawer = useCallback(({ contact, opportunity, activity, scheduleOrigin = null, onConcludeActivity, onScheduled }) =>
        setCallRequest({ contact, opportunity, activity, scheduleOrigin, onConcludeActivity, onScheduled }), []);

    const closeCallDrawer = () => setCallRequest(null);

    return (
        <VoiceCallContext.Provider value={{ openCallDrawer }}>
            {children}

            {callRequest && (
                <CallDrawer
                    contact={callRequest.contact}
                    opportunity={callRequest.opportunity}
                    activity={callRequest.activity}
                    scheduleOrigin={callRequest.scheduleOrigin}
                    onConcludeActivity={callRequest.onConcludeActivity}
                    onScheduled={callRequest.onScheduled}
                    onExit={closeCallDrawer}
                />
            )}
        </VoiceCallContext.Provider>
    );
};
